import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map, switchMap, toArray } from 'rxjs/operators';
import { AntDataResponse, AntSortLoadingParams } from '@antony/ng-ui';
import { ResourceApiService } from '@api/models';
import { ArticleDto, ArticlesApiService } from '@api/api.service';
import { LoadingParamsUtils } from '@api/utils';

@Injectable({
  providedIn: 'root',
})
export class ArticleService implements ResourceApiService<ArticleDto> {
  constructor(private api: ArticlesApiService) {}

  getData(params: Partial<AntSortLoadingParams<ArticleDto>>): Observable<AntDataResponse<ArticleDto>> {
    return this.api
      .getPagedArticles(
        LoadingParamsUtils.getSkipFrom(params),
        LoadingParamsUtils.getTakeFrom(params),
        LoadingParamsUtils.getFilterNamesFrom(params),
        LoadingParamsUtils.getFilterValueFrom(params),
        LoadingParamsUtils.getSortNamesFrom(params),
        LoadingParamsUtils.getApiSortDirection(params)
      )
      .pipe(
        map((res) => ({
          data: res.data || [],
          maxCount: res.maxCount || 0,
        }))
      );
  }

  get(id: number): Observable<ArticleDto> {
    return this.api.getArticle(id).pipe(map((x) => x.data as ArticleDto));
  }

  create(item: ArticleDto): Observable<ArticleDto> {
    return this.api.createArticle(item).pipe(map((x) => x.data as ArticleDto));
  }

  update(id: number, item: ArticleDto): Observable<ArticleDto> {
    return this.api.updateArticle(id, item).pipe(map((x) => x.data as ArticleDto));
  }

  delete(id: number): Observable<boolean> {
    return this.api.deleteArticle(id).pipe(map((x) => x.success));
  }

  deleteBulk(ids: number[]): Observable<boolean[]> {
    return this.api.deleteBulkArticles(ids).pipe(
      map((res) => res.data || []),
      switchMap((responses) => from(responses)),
      map((res) => res.success),
      toArray()
    );
  }
}
